import Typography from 'APP/Converse/Typography'
import { Pressable, View } from 'react-native'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'

export const Container = styled(SafeAreaView).attrs({ edges: ['top'] })`
  background-color: ${({ theme }) => theme.colors.homeBannerBg};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  width: 100%;
`

export const IconCircle = styled(View)`
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.metrics.icon.small}px;
  width: ${({ theme }) => theme.metrics.icon.small}px;
  height: ${({ theme }) => theme.metrics.icon.small}px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Image = styled.Image`
  width: ${({ theme }) => theme.metrics.icon.medium}px;
  height: ${({ theme }) => theme.metrics.icon.medium}px;
`

export const Title = styled(Typography).attrs(() => ({
  variant: 'bodyLarge',
}))`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fonts.fontSize.h3}px;
  margin-left: ${({ theme }) => theme.metrics.baseMargin / 1.5}px;
`

export const HomeButton = styled(Pressable)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`
